import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Avatar from '../Avatar/Avatar';
import { StyledListIText, StyledListItem } from './CurrentSpace.styled';
import { SpaceType } from './propTypes'; // @emotion.styled gives prop error if we pass true or false as prop, solution is to pass 1 or 0
// issue details - https://stackoverflow.com/questions/49784294/warning-received-false-for-a-non-boolean-attribute-how-do-i-pass-a-boolean-f

import { jsx as ___EmotionJSX } from "@emotion/core";

const CurrentSpace = ({
  space,
  highlightedIndex
}) => ___EmotionJSX(React.Fragment, null, ___EmotionJSX(StyledListItem, {
  highlighted: highlightedIndex === 0 ? 1 : 0,
  component: "div",
  "data-testid": "current-space"
}, ___EmotionJSX(Avatar, {
  name: space.name,
  url: space.avatar,
  size: "medium"
}), ___EmotionJSX(StyledListIText, {
  disableTypography: true,
  inset: true,
  primary: space.name
})), ___EmotionJSX(Divider, null));

CurrentSpace.propTypes = {
  space: SpaceType.isRequired,
  highlightedIndex: PropTypes.number.isRequired
};
export default CurrentSpace;
//# sourceMappingURL=CurrentSpace.js.map